package com.milta.core.localization.translations.bg

import com.milta.core.localization.SpreadsheetImportStrings

internal val SpreadsheetImport = SpreadsheetImportStrings(
    importFileTitle = "Импортиране на файл",
    analysingTitle = "Анализ на файла…",
    analysingSubtitle = "Идентифицираме колоните и откриваме доставките в таблицата.",
    fileSentSuffix = "изпратен току-що",
    structuredFormatBannerTitle = "Форматът е разпознат.",
    structuredFormatBannerMessage = "Колоните бяха съпоставени автоматично, не е необходима корекция.",
    columnsInterpretedBannerTitle = "Колоните са интерпретирани автоматично.",
    columnsInterpretedBannerMessage = "Проверете отбелязаните доставки, преди да ги добавите.",
    completePillLabel = "Всичко е пълно",
    invalidFileTitle = "Файлът не се поддържа.",
    invalidFileMessage = "Импортирайте валиден Excel (.xlsx) или CSV (.csv) файл.",
    chooseAnotherFileButton = "Изберете друг файл",
    extractionFailedTitle = "Този файл не може да бъде прочетен.",
    extractionFailedMessage = "Таблицата изглежда празна или структурата й не е разпозната — проверете съдържанието или въведете доставките ръчно.",
    retryWithNewFileButton = "Опитайте отново с друг файл",
    serviceUnavailableTitle = "Услугата за анализ временно не е достъпна.",
    serviceUnavailableMessage = "Опитайте отново след малко или попълнете тази доставка ръчно междувременно.",
)
